export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_SINGLE_CATEGORY = "GET_SINGLE_CATEGORY";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const ADD_CATEGORY_SUCCESS = "ADD_CATEGORY_SUCCESS";
export const ADD_CATEGORY_FAILURE = "ADD_CATEGORY_FAILURE";
export const HIDE_CATEGORY = "HIDE_CATEGORY";
export const UNHIDE_CATEGORY = "UNHIDE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_FAILURE = "DELETE_CATEGORY_FAILURE";
export const ADD_NEW_ATTRIBUTE = "ADD_NEW_ATTRIBUTE";
export const EDIT_ATTRIBUTE = "EDIT_ATTRIBUTE";
export const APPEND_ATTRIBUTE_VALUES = "APPEND_ATTRIBUTE_VALUES";
export const CREATE_PROGRESS_MONITOR = "CREATE_PROGRESS_MONITOR";
export const SET_MONITOR_ID = "SET_MONITOR_ID";
export const GET_PROGRESS_MONITOR = "GET_PROGRESS_MONITOR";
export const GET_PROGRESS_MONITOR_COMPLETE = "GET_PROGRESS_MONITOR_COMPLETE";
export const GET_PROGRESS_MONITOR_CLOSE = "GET_PROGRESS_MONITOR_CLOSE";
export const UPDATE_MONITOR_REFLECTED_INDEXES =
  "UPDATE_MONITOR_REFLECTED_INDEXES";

export const allCategories = (payload) => ({
  type: GET_CATEGORIES,
  payload,
});

export const SingleCategory = (payload) => ({
  type: GET_SINGLE_CATEGORY,
  payload,
});

export const allCategoriesSuccess = (payload) => ({
  type: GET_CATEGORIES_SUCCESS,
  payload,
});
export const allCategoriesFailure = (payload) => ({
  type: GET_CATEGORIES_FAILURE,
  payload,
});

export const addCategory = (payload) => ({
  type: ADD_CATEGORY,
  payload,
});

export const editCategory = (payload) => ({
  type: EDIT_CATEGORY,
  payload,
});

export const addCategorySuccess = (payload) => ({
  type: ADD_CATEGORY_SUCCESS,
  payload,
});
export const addCategoryFailure = (payload) => ({
  type: ADD_CATEGORY_FAILURE,
  payload,
});

export const hideCategory = (payload) => ({
  type: HIDE_CATEGORY,
  payload,
});

export const unHideCategory = (payload) => ({
  type: UNHIDE_CATEGORY,
  payload,
});

export const deleteCategory = (payload) => ({
  type: DELETE_CATEGORY,
  payload,
});
export const deleteCategorySuccess = (payload) => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload,
});
export const deleteCategoryFailure = (payload) => ({
  type: DELETE_CATEGORY_FAILURE,
  payload,
});

export const add_new_attribute = (payload) => ({
  type: ADD_NEW_ATTRIBUTE,
  payload,
});

export const edit_attribute = (payload) => ({
  type: EDIT_ATTRIBUTE,
  payload,
});

export const append_attribute_values = (payload) => ({
  type: APPEND_ATTRIBUTE_VALUES,
  payload,
});

export const create_progress_monitor = (payload) => ({
  type: CREATE_PROGRESS_MONITOR,
  payload,
});

export const set_monitor_id = (payload) => ({
  type: SET_MONITOR_ID,
  payload,
});

export const get_progress_monitor = (payload) => ({
  type: GET_PROGRESS_MONITOR,
  payload,
});

export const get_progress_monitor_complete = (payload) => ({
  type: GET_PROGRESS_MONITOR_COMPLETE,
  payload,
});

export const get_progress_monitor_close = (payload) => ({
  type: GET_PROGRESS_MONITOR_CLOSE,
  payload,
});

export const update_monitor_reflected_indexes = (payload) => ({
  type: "UPDATE_MONITOR_REFLECTED_INDEXES",
  payload,
});
